import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
import cx from 'classnames';
import styles from './Icon.module.scss';
const Icon = ({ className, isSpin, prefix = 'wf-icon', name, style, 
// color = '#6d849b',
color = 'inherit', hoverColor, onClick, size = 20, tabIndex = 0, }) => {
    const activeColor = hoverColor ?? color;
    return (_jsx("i", { style: {
            fontSize: size,
            width: size,
            minWidth: size,
            '--color': color,
            '--hover-color': activeColor,
            ...style,
        }, className: cx(prefix, `${prefix}-${name}`, { [styles.spin]: isSpin }, styles.icon, className), tabIndex: tabIndex, onClick: onClick, role: "button" }));
};
export default Object.assign(memo(Icon), { displayName: 'Icon' });
